import { PageHead } from "@generalapplications/html-render/react";
import { PageHero } from "@/app/common/components/composite/layout/PageHero";
import { PageSection } from "@/app/common/components/composite/layout/PageSection";
import {
  RevealGroup,
  RevealItem,
} from "@/app/common/components/composite/motion/RevealGroup";
import { SummaryCard } from "@/app/common/components/composite/list/SummaryCard";
import { capabilities, capabilitiesIndexPage } from "@/content/capabilities";
import { pageHead } from "@/app/common/functions/seo/pageHead";
import { routes } from "@/app/common/functions/routes/routes";
import { Grid, PageArticle } from "@generalapplications/ui";

export function CapabilitiesPage() {
  const head = pageHead({
    path: routes.capabilities.index,
    title: capabilitiesIndexPage.seoTitle,
    description: capabilitiesIndexPage.seoDescription,
    imagePath: capabilitiesIndexPage.image,
  });

  return (
    <PageArticle rhythm="xl">
      <PageHead head={head} />
      <PageHero
        headline={capabilitiesIndexPage.headline}
        copy={capabilitiesIndexPage.heroCopy}
        image={capabilitiesIndexPage.image}
      />

      <PageSection
        title={capabilitiesIndexPage.introTitle}
        body={capabilitiesIndexPage.introCopy}
      />

      <RevealGroup>
        <Grid columns={{ base: 1, md: 2 }} gap="xl">
          {capabilities.map((capability) => (
            <RevealItem key={capability.slug}>
              <SummaryCard
                title={capability.title}
                summary={capability.summary}
                href={routes.capabilities.detail(capability.slug)}
              />
            </RevealItem>
          ))}
        </Grid>
      </RevealGroup>
    </PageArticle>
  );
}
